import styled from 'styled-components'

export const VisitButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 90px;
  max-height: 52px;
  cursor: pointer;

  @media (min-width: 768px) {
    max-width: 400px;
    max-height: 260px;
    border: 1px solid rgba(112,112,112, .1);
  }

  &:hover {
    .arrow-right {
      transform: translateX(10px);
      @media (min-width: 768px) { transform: translateX(16px); }
    }
  }
`

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 50px;

  @media (min-width: 768px) {
    margin-bottom: 12px;
    width: 180px;
    height: 120px;
  }
`

export const CharacterIcon = styled.img`
  width: 24px;
  height: auto;

  @media (min-width: 768px) { width: 70px; }
`

export const ContainerText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2px;

  @media (min-width: 768px) { padding-top: 4px; }
`

export const Title = styled.p`
  font-family: 'Amorim Sans Book', sans-serif;
  font-size: 10px;
  letter-spacing: 0.5px;
  color: #1D3739;
  margin: 0;
  padding: 0;

  @media (min-width: 768px) { font-size: 24px; }
`
export const ArrowLeftContainer = styled.div`
  display: flex;
  margin-top: 5px;
  width: 26px;
  height: 14px;

  @media (min-width: 768px) { width: 30px; margin-top: 10px; }
`

export const RightArrow = styled.img`
  width: 20px;
  height: 11px;
  transform: translateX(6px);
  transition: all .2s ease-in-out;

  @media (min-width: 768px) { transform: translateX(10px); }
`